/***************
 * TODO: The provider props here is just basic change handling, very similar to other provider props.
 * Should think about how some of this can be made common.
 ****************/

// Only props you want to override on the consumer need to be returned.
export const getStandardisationQueryProviderProps = (consumerProps, providerData) => {
  const { name, onChange: consumerOnChange, value: consumerValue } = consumerProps;
  const { setValue, data } = providerData;

  let providerProps = { hasInjectedProps: true };

  // Set value
  if (name && consumerValue === undefined) {
    let value = data[name];

    if (value === undefined) value = null; // Remove undefined
    providerProps.value = value;
  }

  // Set onChange
  if (name && !consumerOnChange) {
    const onChange = ({ data: { value } = {} }) => {
      if (name !== undefined && value !== undefined) setValue({ name, value });
    };

    providerProps.onChange = onChange;
  }

  return providerProps;
};
